function verificaSiglaUnidade(unidade) {
    let sigla = unidade;
    switch(unidade.trim()) {
        case "5201183 Faculdade SENAI da Paraíba":
            sigla = "FACULDADE";
            break;
        case "1117489 Centro de Formação Profissional Professor Stenio Lopes":
            sigla = "SL";
            break;
        case "1117490 Centro de Inovação e Tecnologia Industrial - CITI":
            sigla = "CITI";
            break;
        case "1117488 Centro de Educação Profissional Odilon Ribeiro Coutinho":
            sigla = "ORC";
            break;
        case "1117487 Centro de Formação Prof. Eng. Jose William Lemos Leal":
            sigla = "JWLL";
            break;
        case "1117491 Centro de Tecnologia do Couro e do Calçado Albano Franco":
            sigla = "CTCC";
            break;
        case "5140965 Centro de Formação Profissional Miriam Benevides Gadelha":
            sigla = "MBG SOUSA";
            break;
        case "1169095 Centro de Ações Móveis - CAM":
            sigla = "CITI/CAM";
            break;
        case "5297028 Centro de Formação Profissional Robson Braga de Andrade":
            sigla = "RBA";
            break;
    }
    return sigla
}

function verificaSiglaUnidade2(unidade) {
    let sigla = unidade;
    switch(unidade.trim()) {
        case "FACULDADE SENAI":
            sigla = "FACULDADE";
            break;
        case "CEP PROF. STÊNIO LOPES":
            sigla = "SL";
            break;
        case "1117490 Centro de Inovação e Tecnologia Industrial - CITI":
            sigla = "CITI";
            break;
        case "CEP ODILON RIBEIRO COUTINHO":
            sigla = "ORC";
            break;
        case "CEP JOSÉ WILLIAM LEMOS LEAL":
            sigla = "JWLL";
            break;
        case "CTCC ALBANO FRANCO" :
            sigla = "CTCC";
            break;
        case "CFP MIRIAM BENEVIDES GADELHA":
            sigla = "MBG SOUSA";
            break;
        case "CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL":
            sigla = "CITI/CAM";
            break;
        case "ROBSON BRAGA DE ANDRADE":
            sigla = "RBA";
            break;
    }
    return sigla
}

function formataNumero(numero) {
    try {
        return numero.toLocaleString('pt-BR');
    } catch (error) {
        return 0;
    }
}

function formataPercentual(valorMeta, valorRealizado, atributo) {
    try {
        let totalMeta = valorMeta[`${atributo}_pago`] + valorMeta[`${atributo}_nao_regimental`] + valorMeta[`${atributo}_regimental`];
        let totalRealizado = valorRealizado[`${atributo}_pago`] + valorRealizado[`${atributo}_nao_regimental`] + valorRealizado[`${atributo}_regimental`];
        let percentual = totalMeta === 0 ? 0 : totalRealizado / totalMeta;
        return percentual.toLocaleString('pt-BR', { style: 'percent' });
    } catch (error) {
        return 0;
    }
}

function formataPercentualTotal(total, atributo) {
    try {
        let totalMeta = total[`${atributo}_pago`] + total[`${atributo}_nao_regimental`] + total[`${atributo}_regimental`];
        let totalRealizado = total[`r_${atributo}_pago`] + total[`r_${atributo}_nao_regimental`] + total[`r_${atributo}_regimental`];
        let percentual = totalMeta === 0 ? 0 : totalRealizado / totalMeta;
        return percentual.toLocaleString('pt-BR', { style: 'percent' });
    } catch (error) {
        return 0;
    }
}

// TabelaMetaRealizado

function getUnidade(unidade) {
    let sigla, nome;
    switch(unidade) {
        case "5201183 Faculdade SENAI da Paraíba":
            sigla = "FACULDADE";
            nome = "FACULDADE SENAI";
            break;
        case "1117489 Centro de Formação Profissional Professor Stenio Lopes":
            sigla = "SL";
            nome = "CEP PROF. STÊNIO LOPES";
            break;
        case "1117490 Centro de Inovação e Tecnologia Industrial - CITI":
            sigla = "CITI";
            nome = "CITI";
            break;
        case "1117488 Centro de Educação Profissional Odilon Ribeiro Coutinho":
            sigla = "ORC";
            nome = "CEP ODILON RIBEIRO COUTINHO";
            break;
        case "1117487 Centro de Formação Prof. Eng. Jose William Lemos Leal":
            sigla = "JWLL";
            nome = "CEP JOSÉ WILLIAM LEMOS LEAL";
            break;
        case "1117491 Centro de Tecnologia do Couro e do Calçado Albano Franco":
            sigla = "CTCC";
            nome = "CTCC ALBANO FRANCO";
            break;
        case "5140965 Centro de Formação Profissional Miriam Benevides Gadelha":
            sigla = "MBG SOUSA";
            nome = "CFP MIRIAM BENEVIDES GADELHA";
            break;
        case "1169095 Centro de Ações Móveis - CAM":
            sigla = "CITI/CAM";
            nome = "CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL";
            break;
        case "5297028 Centro de Formação Profissional Robson Braga de Andrade\t":
            sigla = "RBA";
            nome = "ROBSON BRAGA DE ANDRADE";
            break;
        default:
            sigla = "DR"
            nome = "DR";
            break;
    }

    return { sigla, nome }

}

function getUnidadeRealizado(unidade) {

    let sigla, nome;
    switch(unidade) {
        case "FACULDADE SENAI":
            sigla = "FACULDADE";
            nome = "5201183 Faculdade SENAI da Paraíba";
            break;
        case "CEP PROF. STÊNIO LOPES":
            sigla = "SL";
            nome = "1117489 Centro de Formação Profissional Professor Stenio Lopes";
            break;
        case "":
            sigla = "CITI";
            nome = "1117490 Centro de Inovação e Tecnologia Industrial - CITI";
            break;
        case "CEP ODILON RIBEIRO COUTINHO":
            sigla = "ORC";
            nome = "1117488 Centro de Educação Profissional Odilon Ribeiro Coutinho";
            break;
        case "CEP JOSÉ WILLIAM LEMOS LEAL":
            sigla = "JWLL";
            nome = "1117487 Centro de Formação Prof. Eng. Jose William Lemos Leal";
            break;
        case "CTCC ALBANO FRANCO":
            sigla = "CTCC";
            nome = "1117491 Centro de Tecnologia do Couro e do Calçado Albano Franco";
            break;
        case "CFP MIRIAM BENEVIDES GADELHA":
            sigla = "MBG SOUSA";
            nome = "5140965 Centro de Formação Profissional Miriam Benevides Gadelha";
            break;
        case "CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL":
            sigla = "CITI/CAM";
            nome = "1169095 Centro de Ações Móveis - CAM";
            break;
        case "ROBSON BRAGA DE ANDRADE":
            sigla = "RBA";
            nome = "5297028 Centro de Formação Profissional Robson Braga de Andrade\t";
            break;
        default:
            nome = "DR";
            break;
    }
    
    return nome;

}

function getModalidades(modalidade, inverter=false) {
    
    let modalidadesMetas = [
        "Iniciação Profissional Presencial",
        "Iniciação Profissional à Distância",
        "Aprendizagem Industrial Presencial",
        "Aprendizagem Industrial a Distância",
        "Aprendizagem Industrial Técnica Presenc.",
        "Aprendizagem Industrial Técnica (EAD)",
        "Qualificação Profissional Presencial",
        "Qualificação Profissional a Distância",
        "Aperfeiçoamento/Espec.Profiss.Presencial",
        "Aperfeiçoamento/Espec.Profis.a Distância",
        "Técnico de Nível Médio Presencial",
        "Técnico de Nível Médio a Distância",
        "Graduação Tecnológica Presencial",
        "Graduação Tecnológica (EAD)",
        "Cursos de Extensão Presencial",
        "Cursos de Extensão (EAD)",
        'Pós-Graduação "lato sensu" - Especializa',
        'Pós-Graduação "lato sensu" - Especializa (EAD)',
        "Técnico N.Médio Presencial Itinerário V",
        "Técnico N.Médio (EAD) Itinerário V",
        "57 Aperfeiçoamento Profissional",
        "57 Aperfeiçoamento Profissional (EAD)"
    ]

    let modalidadesRealizados = [
        "5 Iniciação Profissional",
        "5 Iniciação Profissional (EAD)",
        "11 Aprendizagem Industrial básica",
        "11 Aprendizagem Industrial básica (EAD)",
        "15 Aprendizagem Industrial Técnica de Nível Médio",
        "15 Aprendizagem Industrial Técnica de Nível Médio (EAD)",
        "21 Qualificação Profissional",
        "21 Qualificação Profissional (EAD)",
        "58 Aperfeiçoamento/Especialização Profissional",
        "58 Aperfeiçoamento/Especialização Profissional (EAD)",
        "31 Técnico de Nível Médio",
        "31 Técnico de Nível Médio (EAD)",
        "41 Graduação Tecnológica",
        "41 Graduação Tecnológica (EAD)",
        "87 Cursos de Extensão",
        "87 Cursos de Extensão (EAD)",
        '91 Pós-Graduação "Lato-Sensu" - Especialização',
        '91 Pós-Graduação "Lato-Sensu" - Especialização(EAD)',
        "32 Técnico de Nível Médio - Itinerário V Ensino Médio",
        "32 Técnico de Nível Médio - Itinerário V Ensino Médio (EAD)",
        "57 Aperfeiçoamento Profissional",
        "57 Aperfeiçoamento Profissional (EAD)"
    ]

    let dados;
    if(inverter) {
        dados = modalidadesMetas[modalidadesRealizados.indexOf(modalidade)]
    } else {
        dados = modalidadesRealizados[modalidadesMetas.indexOf(modalidade)]
    }
    
    return dados;

    //return modalidadesRealizados[modalidadesMetas.indexOf(modalidade)]
}

function verificaValorModalidade(valorRealizado, modal) {
    
    let obj = {
        hora_nao_regimental: 0,
        hora_pago: 0,
        hora_regimental: 0,
        matricula_nao_regimental: 0,
        matricula_pago: 0,
        matricula_regimental: 0,
    }

    try {
        Object.keys(obj).map(tipo => {
            obj[tipo] = valorRealizado["modalidades"][modal][tipo];
        });

    } catch (error) {
        let resultado = 0;
    }
    
    return obj;

}

function retornaArrayModalidades() {
    let modalidadesRealizados = [
        "5 Iniciação Profissional",
        "5 Iniciação Profissional (EAD)",
        "11 Aprendizagem Industrial básica",
        "11 Aprendizagem Industrial básica (EAD)",
        "15 Aprendizagem Industrial Técnica de Nível Médio",
        "15 Aprendizagem Industrial Técnica de Nível Médio (EAD)",
        "21 Qualificação Profissional",
        "21 Qualificação Profissional (EAD)",
        "58 Aperfeiçoamento/Especialização Profissional",
        "58 Aperfeiçoamento/Especialização Profissional (EAD)",
        "31 Técnico de Nível Médio",
        "31 Técnico de Nível Médio (EAD)",
        "41 Graduação Tecnológica",
        "41 Graduação Tecnológica (EAD)",
        "87 Cursos de Extensão",
        "87 Cursos de Extensão (EAD)",
        '91 Pós-Graduação "Lato-Sensu" - Especialização',
        '91 Pós-Graduação "Lato-Sensu" - Especialização(EAD)',
        "32 Técnico de Nível Médio - Itinerário V Ensino Médio",
        "32 Técnico de Nível Médio - Itinerário V Ensino Médio (EAD)",
        "57 Aperfeiçoamento Profissional",
        "57 Aperfeiçoamento Profissional (EAD)"
    ]
    return modalidadesRealizados;
}

export default { 
    getUnidade, 
    getModalidades, 
    getUnidadeRealizado, 
    verificaValorModalidade, 
    retornaArrayModalidades,

    verificaSiglaUnidade, 
    verificaSiglaUnidade2, 
    formataNumero,
    formataPercentual,
    formataPercentualTotal
}